import LTR from "@brand-icons/global/pause/pause-ltr.svg";

import { iconFactory } from "../iconFactory";

export const PauseIcon = iconFactory("PauseIcon", LTR);
